// ============================================
// Dropdown.js
// アーカイブページ用セレクトボックスドロップダウン
//
// 動作:
//   data-archive-dropdown 属性を持つ <select> 要素の値が変わると、
//   その値を URL として window.location.assign() で遷移する。
//
// 用途:
//   カテゴリや年月のアーカイブ一覧ページで、セレクトボックスによる
//   ページ移動（フィルタリング）を実装するときに使用する。
//
// HTML 例:
//   <select data-archive-dropdown>
//     <option value="">カテゴリを選択</option>
//     <option value="/news/category/info/">お知らせ</option>
//     <option value="/news/category/event/">イベント</option>
//   </select>
// ============================================
function archiveDropdown() {
  // data-archive-dropdown 属性を持つ全セレクトボックスを対象にする
  document.querySelectorAll('[data-archive-dropdown]').forEach((select) => {
    // 型チェック：<select> 要素でない場合はスキップ（念のため）
    if (!(select instanceof HTMLSelectElement)) return;

    select.addEventListener('change', () => {
      const url = select.value;

      // 値が空（「選択してください」等のプレースホルダー）の場合は遷移しない
      if (!url) return;

      // 防御的チェック: http(s) 以外のスキーム（javascript: 等）は遷移させない
      let dest;
      try {
        dest = new URL(url, window.location.origin);
      } catch {
        return; // URL として解釈できない値は無視する
      }
      if (dest.protocol !== 'http:' && dest.protocol !== 'https:') return;

      // assign() はブラウザの履歴に残る（戻るボタンで前のページに戻れる）
      // 履歴に残したくない場合は replace() を使う
      window.location.assign(dest.href);
    });
  });
}

export { archiveDropdown };
